import { render, staticRenderFns } from "./YesOrNoRadio.vue?vue&type=template&id=56bfe1c2&"
import script from "./YesOrNoRadio.vue?vue&type=script&lang=js&"
export * from "./YesOrNoRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports